import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  & > div:last-child {
    display: flex;
  }
`;

export const MainContainer = styled.div`
  height: 100%;
  .ant-table-content .ant-table-tbody {
    .ant-table-expanded-row td > div {
      padding: 0;
    }
    .ant-table-row td > div {
      padding: 9px 12px;
    }
  }
`;
